export let MapBorder;(function(r){r[r["LEFT"]=0]="LEFT";r[r["BOTTOM"]=1]="BOTTOM"})(MapBorder||(MapBorder={}));